module.exports = __webpack_public_path__ + "img/garwin-ind.1edc7ab9.png";